import {
    ContextMenuItem,
    ContextMenuSeparator,
    ContextMenuShortcut,
    ContextMenuSub,
    ContextMenuSubContent,
    ContextMenuSubTrigger,
} from '@/components/ui/context-menu'
import { buildNodePath, buildNodePathAbove } from '@/features/drive/entities/directory/directory-context'
import { useNodeMoveActionContext } from '@/features/drive/functionalities/actions/node/core/node-move-action/node-move-action-context'
import { NodeMoveActionSubMenu } from '@/features/drive/functionalities/actions/node/core/node-move-action/node-move-action-sub-menu'
import { useNodeMoveActionSubMenu } from '@/features/drive/functionalities/actions/node/core/node-move-action/utils/use-node-move-action-sub-menu'
import { Target } from 'lucide-react'

export const NodeMoveActionContextSubMenu = () => {
    const { path, level, mode, isEntrypoint, onSuccess, name, as } = useNodeMoveActionContext()

    const {
        isOpen,
        directory,
        parentNode,
        parentPath,
        filteredContent,
        showMoveHereItem,
        showGoUpItem,
        onMoveHereClick,
        handleOpenChange,
        handleArrowRight,
        handleMouseEnter,
        handleMouseLeave,
    } = useNodeMoveActionSubMenu({ path, level, mode })

    return (
        <ContextMenuSub open={isOpen} onOpenChange={(v) => handleOpenChange(v, isEntrypoint)}>
            <ContextMenuSubTrigger
                onKeyDown={(e) => {
                    if (e.key === 'ArrowRight') handleArrowRight()
                }}
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
            >
                {level === 0 && isEntrypoint ? 'Move' : (name ?? directory?.name)}
            </ContextMenuSubTrigger>

            <ContextMenuSubContent className="w-48">
                {showMoveHereItem && (
                    <ContextMenuItem onSelect={onMoveHereClick}>
                        Move here{' '}
                        <ContextMenuShortcut>
                            <Target className="stroke-foreground h-3.5 w-3.5" />
                        </ContextMenuShortcut>
                    </ContextMenuItem>
                )}

                {showGoUpItem && (
                    <NodeMoveActionSubMenu
                        name={`... ${parentNode?.name ?? (parentPath === '/' ? 'Drive' : 'Go up')}`}
                        level={level - 1}
                        key={'sub-menu' + path + 'up'}
                        path={buildNodePathAbove(path)}
                        onSuccess={onSuccess}
                        mode={mode}
                        as={as}
                    />
                )}

                {!!filteredContent?.length && (showGoUpItem || showMoveHereItem) && <ContextMenuSeparator />}

                {filteredContent?.map((node) => {
                    switch (node.type) {
                        case 'DIRECTORY':
                            return (
                                <NodeMoveActionSubMenu
                                    name={node.name}
                                    level={level + 1}
                                    key={'sub-menu' + path + node.slug}
                                    path={buildNodePath(path, node.slug)}
                                    onSuccess={onSuccess}
                                    mode={mode}
                                    as={as}
                                />
                            )

                        default:
                            return null
                    }
                })}

                {isEntrypoint && level === 0 && !filteredContent?.length && !showMoveHereItem && !showGoUpItem && (
                    <ContextMenuItem disabled>No folders available</ContextMenuItem>
                )}
            </ContextMenuSubContent>
        </ContextMenuSub>
    )
}
